export const BASE_REF = '{{base}}';

export function usesBaseRef(body) {
  if (!body) return false;
  return body.trim().startsWith(BASE_REF);
}

export function splitBaseBody(body) {
  if (!body) return { usesBase: false, tail: '' };
  if (!body.startsWith(BASE_REF)) return { usesBase: false, tail: body };
  let tail = body.slice(BASE_REF.length);
  if (tail.startsWith('\r\n')) tail = tail.slice(2);
  else if (tail.startsWith('\n')) tail = tail.slice(1);
  return { usesBase: true, tail };
}

export function buildBodyWithBase(tail) {
  if (!tail || !tail.trim()) return BASE_REF;
  return `${BASE_REF}\n\n${tail}`;
}

export function deriveInheritanceState(body, baseText) {
  if (!body || !body.trim()) return 'empty';
  if (body === BASE_REF) return 'inherited';
  const { usesBase, tail } = splitBaseBody(body);
  if (usesBase && tail.trim()) return 'appending';
  if (usesBase && !tail.trim()) return 'inherited';
  if (baseText && body.trim() === baseText.trim()) return 'inherited_snapshot';
  return 'diverged';
}

export function lintPrompt(body, declaredVars = []) {
  const notes = [];
  const varMatches = [...(body || '').matchAll(/\{\{([a-zA-Z_][a-zA-Z0-9_]*)\}\}/g)];
  const known = new Set(['base', ...declaredVars]);
  varMatches.forEach((m) => {
    if (!known.has(m[1]) && !m[1].startsWith('lib:')) {
      notes.push({ type: 'warning', message: `Undefined variable {{${m[1]}}}` });
    }
  });
  return notes;
}

export function bodyToBotLegacy(body) {
  const { usesBase, tail } = splitBaseBody(body);
  if (!usesBase) return { prompt_mode: 'custom', custom_prompt: body || null };
  if (!tail.trim()) return { prompt_mode: 'assistant', custom_prompt: null };
  return { prompt_mode: 'append', custom_prompt: tail.trim() || null };
}

export function botLegacyToBody(promptMode, customPrompt) {
  const mode = (promptMode || 'assistant').toLowerCase();
  if (mode === 'assistant') return BASE_REF;
  if (mode === 'append') return buildBodyWithBase(customPrompt || '');
  return customPrompt || '';
}

export function heuristicTokenCount(text) {
  if (!text || !text.trim()) return 0;
  return Math.ceil((text || '').length / 4);
}

/** Format dollar cost as cents string for display. */
export function formatCents(dollars) {
  if (dollars == null || dollars <= 0) return null;
  const cents = dollars * 100;
  if (cents < 0.0001) return '<0.0001¢';
  if (cents >= 10) return `${cents.toFixed(1)}¢`;
  if (cents >= 1) return `${cents.toFixed(2)}¢`;
  return `${cents.toFixed(3)}¢`;
}
